/**
 * Map stored prompt group id to the same label shown in the AI picker.
 */

import {
  optionLabelForGroup,
  type TreeGroupLike,
} from '@/features/campaign-texts/utils/group-tree.utils';

const MASTER_ID = 'master';

export function resolvePromptGroupLabel(
  groupId: string | undefined,
  groups: TreeGroupLike[] | undefined,
): string | undefined {
  if (!groupId || groupId === MASTER_ID) return 'Default';
  if (!groups?.length) return undefined;
  const g = groups.find((x) => x.id === groupId);
  if (!g) return undefined;
  return optionLabelForGroup(g, groups);
}
